import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import IdevraSite from "@/pages/IdevraSite";
import Inbox from "@/pages/Inbox";
import MolecularCursor from "@/pages/idevra/MolecularCursor";
import CookieConsent from "@/pages/idevra/CookieConsent";
import AdminGate from "@/pages/idevra/AdminGate";

function App() {
  return (
    <div className="App">
      <MolecularCursor />
      <CookieConsent />
      <BrowserRouter>
        <AdminGate />
        <Routes>
          <Route path="/" element={<IdevraSite />} />
          <Route path="/v/:slug" element={<IdevraSite />} />
          <Route path="/founder" element={<IdevraSite />} />
          <Route path="/vault" element={<IdevraSite />} />
          <Route path="/inbox" element={<Inbox />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
